// import stimulus-flatpickr wrapper controller to extend it
import Flatpickr from "stimulus-flatpickr";

// import a theme (could be in your main CSS entry too...)
import "flatpickr/dist/themes/dark.css";

// create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {
  initialize() {
    let isTimePicker = $(this.element).data("time-picker") || false;
    let format = isTimePicker ? "m/d/Y h:i K" : "m/d/Y";

    this.config = {
      enableTime: isTimePicker,
      dateFormat: format,
      allowInput: true
    };
  }
}
